import { queryStringify, STORAGE_EVENT } from '@utils'
import { createMutationHelper, createRequestHelper, createStorageProvider } from '@utils/swr'
import { type CampaignProductsByProjectCodeRequest } from '../types/apiRequest'
import { type CampaignProductsResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const provider = createStorageProvider('ec-products-by-project-code', STORAGE_EVENT.sessionStorage)

const { useRequest } = createRequestHelper<FortuneApis['post']['campaignProductsByProjectCode'], CampaignProductsResponse, CampaignProductsByProjectCodeRequest>({
  client: 'fortune',
  key: (params) => {
    if (!params) return null
    const { country_code, products, campaign_code, merchant_id } = params
    if (!country_code || !campaign_code || !products.length) return null
    return `/campaigns/${campaign_code}/products/by_project_code?${queryStringify({
      country_code,
      product_ids: products.map(product => `${product.project_code}-${product.product_id}`).join(','),
      merchant_id,
    })}`
  },
  fetcher: client => (url, params) => {
    if (!params?.country_code || !params?.campaign_code) {
      throw new Error('[useApiCampaignProductsByProjectCode] country_code and campaign_code are required!')
    }
    return client.post(url, {
      country_code: params.country_code,
      products: params.products,
      merchant_id: params.merchant_id,
    })
  },
  provider,
})

export const useApiCampaignProductsByProjectCode = useRequest

const { useMutation } = createMutationHelper<FortuneApis['post']['campaignProductsByProjectCode'], CampaignProductsResponse, CampaignProductsByProjectCodeRequest>({
  client: 'fortune',
  key: '/campaigns/:campaign_code/products/by_project_code',
  fetcher: (_, { client, arg }) => {
    if (!arg.country_code || !arg.campaign_code) {
      return Promise.reject(new Error('[useApiCampaignProductsByProjectCode] country_code and campaign_code are required!'))
    }
    return client.post(`/campaigns/${arg.campaign_code}/products/by_project_code`, {
      country_code: arg.country_code,
      products: arg.products,
      merchant_id: arg.merchant_id,
    })
  },
})

export const useApiMutationCampaignProductsByProjectCode = useMutation
